<ion-content class="modal-outher-container">
  <ion-grid class="content modal-inner-container modal-inner-container--small">
    <ion-row>
      <ion-col>
        <app-modal-header [header]="modalTitle" (close)="close()">
        </app-modal-header>
        <!-- ELEMENTY NIE SĄ OBECNIE UŻYWANE I ZOSTAŁY WYKOMENTOWANE -->
        <!-- <ion-item
          class="input"
          *ngIf="inputType == 'datetime' && !mobile"
          lines="none"
        >
          <div class="control-display">
            <ion-label>{{ inputTitle }}</ion-label>
            <input
              [owlDateTime]="dtmodal"
              [owlDateTimeTrigger]="dtmodal"
              placeholder="{{ inputPlaceholder }}"
              class="selectdate"
              [(ngModel)]="inputValue"
            />
            <owl-date-time #dtmodal firstDayOfWeek="1"></owl-date-time>
          </div>
        </ion-item>

        <ion-item class="input" *ngIf="inputType == 'datetime' && mobile">
          <div class="control-display">
            <ion-label>{{ inputTitle }}</ion-label>
            <ion-datetime
              placeholder="{{ inputPlaceholder }}"
              display-format="HH:mm"
              picker-format="HH:mm"
              [(ngModel)]="inputValue"
            ></ion-datetime>
          </div>
        </ion-item> -->

        <!-- Input type [text] -->

        <ion-item *ngIf="inputType == 'text'" class="input">
          <div class="control-display">
            <ion-label>{{ inputTitle }}</ion-label>
            <ion-input
              [(ngModel)]="inputValue"
              placeholder="{{ inputPlaceholder }}"
            ></ion-input>
          </div>
        </ion-item>

        <ion-item class="input" lines="none">
          <ion-button
            class="button-margin-top-md"
            (click)="save()"
            size="medium"
            slot="end"
            >{{ saveTitle }}</ion-button
          >
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
